import { Array, pipe } from "effect";

export function getAssets<T>(market: {
  baseAsset: T;
  bridgeAssets: readonly [T, T?];
}): T[] {
  const {
    baseAsset,
    bridgeAssets: [firstBridgeAsset, secondBridgeAsset],
  } = market;

  const assets = pipe(
    [baseAsset, firstBridgeAsset, secondBridgeAsset],
    Array.flatMapNullable((asset) => asset)
  );

  return assets;
}
